import { useState } from "react";

import { createTheme, ThemeProvider } from "@mui/material";

import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";

const theme = createTheme({
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: {
          color: "#231F20",
          fontWeight: 700,
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: { color: "#4B4B4B", fontWeight: 400 },
      },
    },
    MuiTableCell: {
      defaultProps: {
        padding: "none",
      },
      styleOverrides: {
        root: {
          paddingLeft: 8,
          height: 32.5,
          borderBottomWidth: 3,
          borderColor: "white",

          "&.active-select": {
            paddingLeft: 2,
            color: "#595959",
            backgroundColor: "#09B0F2",
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
          },
          "&.inactive-select": {
            paddingLeft: 2,
            color: "#595959",
            backgroundColor: "#D9D9D9",
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
          },

          "&.active": {
            color: "#595959",
            backgroundColor: "#F2F8FD",
          },
          "&.inactive": {
            color: "#595959",
            backgroundColor: "#F7F7F7",
          },
        },
      },
    },

    MuiRadio: {
      styleOverrides: {
        root: {
          padding: 0,
          borderColor: "#b3b3b3",
        },
      },
    },
  },
});

const QuotesTable = () => {
  const [selectedRow, setSelectedRow] = useState(0);

  return (
    <ThemeProvider theme={theme}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: 30 }} />
            <TableCell>Origin</TableCell>
            <TableCell>FOB</TableCell>
            <TableCell>Delivered price</TableCell>
            <TableCell>Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {new Array(5).fill(0).map((r, i) => {
            const isSelected = i === selectedRow;
            const className: string = isSelected ? "active" : "inactive";
            const selectClassName: string = isSelected
              ? "active-select"
              : "inactive-select";

            return (
              <TableRow>
                <TableCell
                  className={selectClassName}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedRow(i)}
                >
                  {isSelected ? (
                    <RadioButtonChecked
                      style={{
                        color: "white",
                      }}
                    />
                  ) : (
                    <RadioButtonUnchecked style={{ color: "white" }} />
                  )}
                </TableCell>
                <TableCell className={className}>Wichita, KS</TableCell>
                <TableCell className={className}>$80</TableCell>
                <TableCell className={className}>$200</TableCell>
                <TableCell className={className}>Competitor</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </ThemeProvider>
  );
};

export default QuotesTable;
